import authenticationReducer from './authentication/slice';
import claimReducer from './claim/slice';
import claimAuthorizationsReducer from './claimAuthorizations/slice';
import claimsReducer from './claims/slice';
import configReducer from './config/slice';
import externalContactsReducer from './externalContacts/slice';
import fileContainersReducer from './fileContainers/slice';
import fileUploadReducer from './fileUpload/slice';
import filterReducer from './filters/slice';
import generalMessagesReducer from './generalMessages/slice';
import housingStocksReducer from './housingStocks/slice';
import importReducer from './import/slice';
import insuredRisksReducer from './insuredRisks/slice';
import insuredRisksToPoliciesReducer from './insuredRisksToPolicies/slice';
import layoutReducer from './layout/slice';
import messageTemplatesReducer from './messageTemplates/slice';
import organizationsReducer from './organizations/slice';
import organizationsToRisksReducer from './organizationsToRisks/slice';
import passwordReducer from './password/slice';
import policiesReducer from './policies/slice';
import policiesToRisksReducer from './policiesToRisks/slice';
import policyReducer from './policy/slice';
import reportingReducer from './reporting/slice';
import riskReducer from './risk/slice';
import risksReducer from './risks/slice';
import blobsToOrganizationsReducer from './blobsToOrganizations/slice';
import sidebarReducer from './sidebar/slice';
import settlementsReducer from './settlements/slice';
import stripeReducer from './stripe/slice';
import usersReducer from './users/slice';
import worklistClaimsReducer from './worklistClaims/slice';
import worklistRisksReducer from './worklistRisks/slice';
import worklistsReducer from './worklists/slice';

export default {
  authentication: authenticationReducer,
  blobsToOrganizations: blobsToOrganizationsReducer,
  claim: claimReducer,
  claimAuthorizations: claimAuthorizationsReducer,
  claims: claimsReducer,
  config: configReducer,
  externalContacts: externalContactsReducer,
  fileContainers: fileContainersReducer,
  fileUpload: fileUploadReducer,
  filters: filterReducer,
  generalMessages: generalMessagesReducer,
  housingStocks: housingStocksReducer,
  import: importReducer,
  insuredRisks: insuredRisksReducer,
  insuredRisksToPolicies: insuredRisksToPoliciesReducer,
  layout: layoutReducer,
  messageTemplates: messageTemplatesReducer,
  organizations: organizationsReducer,
  organizationsToRisks: organizationsToRisksReducer,
  password: passwordReducer,
  policies: policiesReducer,
  policiesToRisks: policiesToRisksReducer,
  policy: policyReducer,
  reporting: reportingReducer,
  risk: riskReducer,
  risks: risksReducer,
  settlements: settlementsReducer,
  sidebar: sidebarReducer,
  stripe: stripeReducer,
  users: usersReducer,
  worklistClaims: worklistClaimsReducer,
  worklistRisks: worklistRisksReducer,
  worklists: worklistsReducer
};
